import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bvvretxze3: FaireBrandEntity = {
  token: "b_bvvretxze3",
  type: "brand",
  name: "The Hot Sauce Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/08fdedf60d771063ab8aab7ac162f8dde32aa4bf9d5f897ee83dc73e8a97fc8c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1dd98ad073d87ce1f2d8e58e700b044393a3ac2d0b22a490d3296ca2507a0ba4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/08fdedf60d771063ab8aab7ac162f8dde32aa4bf9d5f897ee83dc73e8a97fc8c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1dd98ad073d87ce1f2d8e58e700b044393a3ac2d0b22a490d3296ca2507a0ba4.jpeg",
  location: "London, ON, CAN",
  minimumOrderDollars: 90,
  rating: 5,
  reviewCount: 2,
  isInsider: false,
  description:
    "Welcome to The Hot Sauce Co., an international award winning, premium small-batch hot sauce manufacturer based in London, Ontario, Canada. As a hungry player in the industry, our commitment is to deliver top-notch, award-winning hot sauces that redefine flavor and elevate culinary experiences.\n\nDedicated to promoting a bold and healthy lifestyle, our products are meticulously crafted using exclusively all-natural fresh ingredients. We take pride in our recognition as a brand that not only values quality and authenticity but also serves as a beacon for health-conscious consumers.\n\nOur diverse clientele, ranging from individuals to families, shares a common thread of prioritizing health and seeking exciting products that align with their values. The Hot Sauce Co. understands the importance of offering products free from artificial additives, seed oils, preservatives, and chemicals. Moreover, our commitment to environmental sustainability is evident in our eco-friendly packaging choices as well as our zero-waste production policy.",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:51.271Z",
    importedBy: "entity-db-cli",
  },
};
